// extracted by mini-css-extract-plugin
module.exports = {"therapies-wrapper":"Therapies_therapies-wrapper__39OQc"};